import React, { useState } from 'react'

import { Box } from '@mui/material'

import TerreniForm from './TerreniForm'

export const TerreniSlider = ({ cantine, setCantine }) => {
    const [isFormOpen, setIsFormOpen] = useState(false);

    return (
        <Box className='customDrawer_container'>
            <Box className='boxContainer__head'>
                <h2 className="boxContainer__title">Registra un Terreno</h2>
            </Box>
            <TerreniForm cantine={cantine} onClose={() => setIsFormOpen(false)} setCantine={setCantine} />
        </Box>
    )
}
